<template>
    <div id="app" v-if="showStatus">
        <nav-bar :menuList="menuList" :language="language"></nav-bar>
        <router-view :key="$route.fullPath"/>
        <Footer :menuList="footerMenuList"></Footer>
    </div>
</template>

<script>
    import NavBar from './components/NavBar.vue'
    import Footer from './components/Footer'
    import {getDictData, getMenuFirst, getMenuTwo} from "./api/HomeService";

    export default {
        name: 'app',
        components: {
            NavBar,
            Footer
        },
        data() {
            return {
                showStatus: false,
                language: '',
                menuList: '',
                footerMenuList: [],
                languageNum: ''
            }
        },

        methods: {
            getMenuList(languageNum) {
                getMenuFirst(languageNum, data => {
                    this.menuList = data;
                    setTimeout(() => {
                        this.setMate();
                    }, 500)
                    this.getMenuChildren(data)
                })
            },

            getMenuChildren(menuList) {
                let index = 0;
                let languageNum = this.languageNum
                for (let i = 0; i < menuList.length; i++) {
                    let sendData = {
                        menuIdParent: menuList[i].menuId,
                        languageNum: languageNum
                    }
                    getMenuTwo(sendData, data => {
                        menuList[i].children = data;
                        index++

                        if (index === this.menuList.length) {
                            console.log('menuList save')
                            window.localStorage.setItem('menuList', JSON.stringify(this.menuList))
                            setTimeout(() => {
                                this.showStatus = true;
                            })

                        }

                        if (data.length > 0) {
                            this.footerMenuList.push(menuList[i])
                        }

                    })
                }
            },

            setMate() {
                let curNav;
                console.log(this.$route);
                if (this.$route.path === "/" || this.$route.name === "Home") {
                    curNav = this.menuList[0]
                } else {
                    for (let i = 0; i < this.menuList.length; i++) {
                        if (this.menuList[i].menuUrl !== "/" && this.$route.path.indexOf(this.menuList[i].menuUrl) !== -1) {
                            curNav = this.menuList[i];
                            break;
                        }
                    }
                }

                // if (window.localStorage.getItem("curNav")) {
                //     curNav = JSON.parse(window.localStorage.getItem("curNav"));
                // } else {
                //     curNav = this.menuList[0]
                // }
                document.title = curNav.title;
                document.getElementsByTagName('meta')[1].setAttribute("content", curNav.description);
                document.getElementsByTagName('meta')[2].setAttribute("content", curNav.keywords);
            }

        },

        created() {

            getDictData("language", data => {
                this.language = data
                window.localStorage.setItem("language", JSON.stringify(this.language))
                this.languageNum = window.localStorage.getItem("languageNum")
                if (this.languageNum) {
                    for (let i = 0; i < this.language.length; i++) {
                        if (this.language[i].dictValue === this.languageNum) {
                            window.localStorage.setItem("languageNum", this.language[i].dictValue)
                            window.localStorage.setItem("languageText", this.language[i].dictLabel);
                            this.languageNum = this.language[i].dictValue;
                            this.getMenuList(this.language[i].dictValue)
                            break;
                        }
                    }
                    return
                }

                for (let i = 0; i < this.language.length; i++) {
                    if (this.language[i].isDefault === "Y") {
                        window.localStorage.setItem("languageNum", this.language[i].dictValue)
                        window.localStorage.setItem("languageText", this.language[i].dictLabel);
                        this.languageNum = this.language[i].dictValue;
                        this.getMenuList(this.language[i].dictValue)
                        break;
                    }
                }
            })
        },
        mounted() {

        }
    }
</script>

<style>

    @font-face {
        font-family: Akrobat-Black;
        src: url('./fonts/Akrobat-Black.otf')
    }

    @font-face {
        font-family: Akrobat-Bold;
        src: url('./fonts/Akrobat-Bold.otf')
    }

    @font-face {
        font-family: Akrobat-ExtraBold;
        src: url('./fonts/Akrobat-ExtraBold.otf')
    }

    @font-face {
        font-family: Akrobat-ExtraLight;
        src: url('./fonts/Akrobat-ExtraLight.otf')
    }

    @font-face {
        font-family: Akrobat-Light;
        src: url('./fonts/Akrobat-Light.otf')
    }

    @font-face {
        font-family: Akrobat-Regular;
        src: url('./fonts/Akrobat-Regular.otf')
    }

    @font-face {
        font-family: Akrobat-SemiBold;
        src: url('./fonts/Akrobat-SemiBold.otf')
    }
</style>

<style lang="scss">
    @import './css/reset.scss';
    @import './css/common.scss';
    @import './css/config.scss';


    .video_box {
        cursor: pointer;
        margin-bottom: 25px;

        .time {
            height: 17px;
            font-size: 14px;
            font-family: Akrobat-Regular, Akrobat;
            font-weight: 400;
            color: #969799;
            line-height: 17px;
        }

        .img_box {
            height: 380px;
            text-align: center;
            position: relative;
            clip-path: polygon(0px 0, calc(100% - 30px) 0,
                    100% 30px, 100% calc(100%),
                    calc(100%) 100%, 20px 100%,
                    0 calc(100%), 0 20px);

            img {
                width: 100%;
                transition: all .5s;
            }

            .play_img {
                width: 54px;
                height: 54px;
                position: absolute;
                left: 50%;
                top: 50%;
                margin-left: -27px;
                margin-top: -27px;
                display: none;
            }

        }


        .video_title {
            width: calc(100% - 55px);
            height: 28px;
            font-size: 20px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 28px;
            margin-bottom: 5px;
            margin-top: 5px;
        }

        .info {
            margin-top: 20px;

            .label {
                display: inline-block;
                margin: 0;
                clip-path: polygon(0px 0, calc(100% - 10px) 0,
                        100% 10px, 100% calc(100%),
                        calc(100%) 100%, 10px 100%,
                        0 calc(100%), 0 10px);
                padding: 4px 12px;
                background: #F4374A;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FAFAFA;

                &:hover {
                    box-shadow: 0px 0px 7px 0px #F4374A;
                }
            }

            .more_icon {
                position: relative;
                top: -2px;
            }

            .text {
                height: 19px;
                font-size: 16px;
                font-family: Akrobat-Regular, Akrobat;
                font-weight: 400;
                color: #969799;
                line-height: 19px;
                margin-left: 2px;
            }

            .right {
                padding-left: 16px;
                background: url("./assets/play-square1.png") no-repeat;
                background-size: 18px;
                background-position-y: 1px;
                margin-top: 5px;
            }

        }

        &:hover {
            .video_title, .text {
                color: #f4374a !important;
            }

            .img_box img {
                transform: scale(1.05);
            }

            .play_img {
                display: block;
            }

            .info .right {
                padding-left: 16px;
                background: url("./assets/play-square2.png") no-repeat;
                background-size: 18px;
                background-position-y: 1px;
            }

        }
    }

    .breadcrumb {
        background-color: #fff !important;

        a, span {
            color: #000 !important;
            cursor: pointer;
        }
    }

    .breadcrumb-item.active::before {
        content: "" !important;
    }

    .swiper-button-next, .swiper-button-prev {
        color: #fff !important;
        z-index: 1 !important;
    }

    .swiper-pagination {
        position: absolute;
        bottom: 25px;
        width: 100%;
        z-index: 1 !important;
    }

    .swiper-pagination-bullet {
        background: #fff !important;
        transform: skewX(-50deg);
        width: 30px !important;
        height: 4px !important;
        border-radius: 0 !important;
        opacity: .5;
    }

    .swiper-pagination-bullet + .swiper-pagination-bullet {
        margin-left: 5px;
    }

    .swiper-pagination-bullet-active {
        opacity: 1 !important;
    }


    .banner_box .swiper-slide {
        max-height: 840px;
        padding: 90px 0;
    }

    .small_nav .card-body {
        padding: 15px !important;
    }


    .product_banner_slide {
        margin: 0 auto;
        text-align: center;

        img {
            width: 330px !important;
            height: 330px;
            margin: 0 auto;
        }
    }

    #app {
        background: #000;
        padding-top: 60px;
    }

    .new_detail_page .content {
        img {
            max-width: 100%;
        }

        p, h3, h4, h5 {
            font-size: 18px;
            line-height: 24px;
        }
    }

    //大于1200px
    @media screen and (min-width: 1200px) {
        .container {
            max-width: 1200px !important;
        }
    }

    .banner_box .carousel-caption {
        bottom: 16% !important;
    }

    .nav-lg {
        padding: 0;
        margin-top: -5px;
    }

    .dropdown-menu li.active .dropdown-item {
        color: #f4374a;

        &:hover {
            color: #f4374a;
        }
    }

    .product_banner .carousel-control-prev, .product_banner .carousel-control-next {
        width: 5% !important;
    }

    .carousel-indicators {
        margin-bottom: 20px;
    }


    .navbar-toggler.not-collapsed, .navbar-dark .navbar-toggler {
        border: 0;
    }

    .navbar-toggler.not-collapsed .navbar-toggler-icon {
        background-image: url("./assets/nav_close.png");
    }

</style>
